import { Label, styled } from '../../../base';

export const ChipsContainer = styled('div')(({ theme }) => ({
    paddingBottom: theme.spacing(5),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
}));

export const StyledLabel = styled(Label)(({ theme }) => ({
    marginInlineEnd: theme.spacing(2),
    marginBottom: theme.spacing(2),
    height: '48px',
    backgroundColor: 'white',
    color: theme.palette.grey[600],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 15,
    paddingInline: theme.spacing(2),
}));
